module.exports = __webpack_public_path__ + "static/media/sale-1.d43129a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sale-1.jpg
// module id = 504
// module chunks = 33